// extracted by mini-css-extract-plugin
export default {"editBtn":"v3_editBtn__qwEvN"};